__turbopack_context__.v({
  "buyNowButton": "ProductCards-module__7YcC2a__buyNowButton" + " " + __turbopack_context__.i(527070)["linkButton"],
  "container": "ProductCards-module__7YcC2a__container",
  "productCard": "ProductCards-module__7YcC2a__productCard",
  "productCards": "ProductCards-module__7YcC2a__productCards" + " " + __turbopack_context__.i(527070)["sectionPadding"],
  "textContent": "ProductCards-module__7YcC2a__textContent",
});
